import { CoordinatorService } from './coordinator.service';
import { createToken, Lexer, CstParser, CstNode } from 'chevrotain';

const And = createToken({
    name: 'And',
    pattern: /AND/i,
});

const Or = createToken({
    name: 'Or',
    pattern: /OR/i,
});

const Not = createToken({
    name: 'Not',
    pattern: /NOT/i,
});

const Compare = createToken({
    name: 'Compare',
    pattern: /(=|!=|<=|>=|<|>)?\d+/,
});

const tokens = [
    // WhiteSpace,
    // Float,
    // Integer,
    And,
    Or,
    Not,
    Compare,
    // IgnoreChars,
];

const lexer = new Lexer(tokens, {
    skipValidations: true,
    deferDefinitionErrorsHandling: true,
});

class NumberParser extends CstParser {
    expression: any;
    visitor: any;

    constructor() {
        super(tokens);
        const $ = this;

        const term = $.RULE('term', () => {
            this.CONSUME(Compare);
            // $.OR([
            //     { ALT: () => this.CONSUME(Float) },
            //     { ALT: () => this.CONSUME(Integer) },
            //     { ALT: () => this.CONSUME(Compare) },
            // ]);
        });
        // const whitespace = $.RULE('whitespace', () => this.CONSUME(IgnoreChars));

        const operators = $.RULE('operators', () => {
            $.OR([
                { ALT: () => this.CONSUME(And) },
                { ALT: () => this.CONSUME(Or) },
                { ALT: () => this.CONSUME(Not) },
                // { ALT: whitespace },
            ]);
        });

        this.expression = $.RULE('expression', () => {
            $.SUBRULE(term);
            $.MANY(() => {
                $.SUBRULE2(operators);
                $.SUBRULE2(term);
            });
        });

        this.performSelfAnalysis();
    }
}

const parser = new NumberParser();
const baseVisitor = parser.getBaseCstVisitorConstructor();

class ExtractorVisitor extends baseVisitor {
    private _tokenLs: { value: string; start: number; isOperator?: boolean }[] = [];

    constructor() {
        super();
        this.validateVisitor();
    }

    term(ctx: any) {
        let x = (ctx.Integer || ctx.Float || ctx.Compare)[0];

        let value = x.image;

        const start = x.startOffset;

        this._tokenLs.push({
            value,
            start,
        });
    }

    operators(ctx: any) {
        console.log(`OPERATOR XX: `, ctx);
        let x = ctx.And || ctx.Or || ctx.Not;
        if (!x) return;
        x = x[0];

        const value = `.${x.image.trim().toLowerCase()}`;
        const start = x.startOffset;
        const isOperator = true;

        this._tokenLs.push({
            value,
            start,
            isOperator,
        });

    }

    whitespace(ctx: any) {
        console.log(`WHITESPACE: `, ctx);
    }

    expression(ctx: any) {
        ctx.operators &&
            ctx.operators.forEach((op: any) => {
                this.visit(op);
            });

        ctx.term &&
            ctx.term.forEach((term: any) => {
                this.visit(term);
            });
    }

    private _finalizeTerm(field: string, ls: string[], argLs: string[] = []) {
        console.log(`FINALIZE TERM: `, field, ls, argLs);
        let v = ls.join('');
        return `("${field}", "${v}${argLs.slice(1).join(',')}")`;
    }

    parse(field: string, cstNode: CstNode) {
        this._tokenLs = [];
        this.visit(cstNode);
        this._tokenLs.sort((a, b) => a.start - b.start);

        const outputLs: string[] = ['.and'];
        const termLs: string[] = [];
        this._tokenLs.forEach((x, i) => {
            if (x.isOperator) {
                outputLs.push(this._finalizeTerm(field, termLs, x.value.split('-')));
                outputLs.push(x.value);
                termLs.length = 0;
            } else {
                termLs.push(x.value);
            }
        });
        outputLs.push(this._finalizeTerm(field, termLs));

        return { interpretation: outputLs.join(''), highlightLs: [] };
    }
}

const extractorVisitor = new ExtractorVisitor();

export class SearchNumberParser {
    constructor(
        private coords: CoordinatorService,
        public field: string,
        private _isPreview = false,
    ) {}

    parse(txt: string) {
        txt = txt.replaceAll(/\s/g, '');
        // console.log(`Parsed string: ||${txt}||`);
        const lexingResult = lexer.tokenize(txt);
        parser.input = lexingResult.tokens;

        if (parser.errors.length > 0) {
            for (const error of parser.errors) {
                console.log(error.message);
            }
            throw new Error('Parsing errors detected!');
        }

        const extracted = extractorVisitor.parse(this.field, parser.expression());

        const resp = {
            interpretation: `return ${this._isPreview ? '$preview' : '$collection'}${extracted.interpretation}`,
            highlightLs: extracted.highlightLs,
        };

        // console.log('NUMBER PARSE RESPONSE: ', resp);
        return resp;
    }
}
